import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './BenefitsWithCredits.css';
import { Button } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';
import { parse } from '../../../../util/urlHelpers';
import config from '../../../../config';
import Benefits from '../../sectionsFlipAndWin/SectionMainBenefits/Benefits';

const { userTypeHorseowner } = config;

export default () => {
    const history = useHistory();
    const { role } = parse(history.location.search);

    return (
        <section className={css.root}>
            <header>
                <h2 className={css.subHeading}>Mehrwert</h2>
                <p className={css.heading}>Deine Vorteile mit Credits</p>
                <p className={css.description}>
                    Credits geben dir Zugang zu allen wichtigen Funktionen: Deine Sichtbarkeit
                    erhöhen, Ansichten deines Profils aufdecken und Anfragen akzeptieren, um ein
                    Match herzustellen.
                </p>
            </header>

            <Benefits />

            <footer className={css.footer}>
                <Button
                    className={css.subLinkPrimary}
                    onClick={() =>
                        history.push(
                            createResourceLocatorString(
                                role === userTypeHorseowner ? 'SignupRider' : 'SignupHorseowner',
                                routeConfiguration()
                            )
                        )
                    }
                >
                    Kostenlos registrieren
                </Button>
            </footer>
        </section>
    );
};
